import React from 'react';
import { Application } from 'appDtos';
import { Translation, useTranslation } from '@chr/online-shared-ui-localizations';

export interface ApplicationCardProps {
  application: Application;
  onOpenApp: (appUrl: string) => void;
}

export const ApplicationCard = ({
  application,
  onOpenApp
}: ApplicationCardProps) => {
  const translate = useTranslation();
  function onOpenClick(){
    onOpenApp(application.url);
  }
  return (
    <div
      id={`card_${application.id}`}
      className="row customer-application"
      data-testid="application"
    >
      <div className="col-xs-9 col-sm-10">
        <h2 id={`name_${application.id}`}>{application.name}</h2>
        <p className="text-muted">
          {application.id === 1 && (<><span>Formerly Navisphere 2.0</span><br /></>)}  
          {application.id === 4 && (<><span>Formerly Navisphere 1.0</span><br /></>)}  
          {application.publicDescription && translate(application.publicDescription)}
          </p>
      </div>
      <div className="col-xs-3 col-sm-2 text-right">
        <a
          id={application.id.toString()}
          className="btn btn-default"
          // onclick and href are both here on purpose.
          // onclick needs to perform some JS before navigation
          // and the href is the path the user will be directed to
          onClick={onOpenClick}
          href={application.url}
        >
          <Translation resourceKey='Open'/>
        </a>
      </div>
    </div>
  );
};

export default ApplicationCard;
